<div class="form-part" [formGroup]="parentForm">
    <mat-form-field>
        <mat-label>{{label | translate}}</mat-label>
        <input type="text" #searchInput matInput [formControlName]="controlName" [matAutocomplete]="auto"
            #trigger="matAutocompleteTrigger" (click)="reopenPanel(trigger)">
        <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option.value" [disabled]="option.disabled">
                    {{option.key}}
                </mat-option>
        </mat-autocomplete>
        <mat-error [appMatErrorMessages]="validators"></mat-error>
    </mat-form-field>
</div>